import styled from "styled-components"
import { device } from "breakpoints"
import { MainColumn } from "components/MainColumn"
import { getGradient } from "helpers/getGradient"

export const HomeBigTeasersContainer = styled(MainColumn)`
  margin-bottom: 140px;
  position: relative;

  @media ${device.desktop} {
    margin-bottom: 150px;
  }

  :before,
  :after {
    background-image: ${getGradient("live")};
    content: "";
    display: block;
    height: 1px;
    width: 110vw;
    left: 50%;
    position: absolute;
    right: 0;
    transform-origin: 50%;
    z-index: -1;

    /* @media ${device.desktop} {
      width: calc(100vw + 30px);
    } */
  }

  :before {
    bottom: -90px;
    transform: rotate(0deg) translateX(-50%);

    @media ${device.tablet} {
      transform: rotate(4deg) translateX(-50%);
    }

    @media ${device.desktop} {
      bottom: -60px;
      transform: rotate(6deg) translateX(-50%);
    }

    @media ${device.large} {
      bottom: -90px;
    }

    @media ${device.big} {
      bottom: -180px;
    }
  }

  :after {
    bottom: -130px;
    transform: rotate(7deg) translateX(-50%);

    @media ${device.tablet} {
      bottom: -140px;
      transform: rotate(12deg) translateX(-50%);
    }

    @media ${device.desktop} {
      bottom: -160px;
      transform: rotate(17deg) translateX(-50%);
    }

    @media ${device.large} {
      bottom: -190px;

    }

    @media ${device.big} {
      bottom: -280px;
      transform: rotate(12deg) translateX(-50%);

    }
  }
`
